import React from 'react'
import styled from 'styled-components'
import RepeatRoundedIcon from '@mui/icons-material/RepeatRounded'
import moment from 'moment'

const WEEKDAYS = ['', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays', 'Sundays']

const cadenceText = (days, weekday) => {
  if (!days) return 'Repeats'
  if (days === 7) return weekday ? `Weekly on ${WEEKDAYS[weekday]}` : 'Weekly'
  if (days === 1) return 'Daily'
  if (days === 14) return 'Fortnightly'
  if (days === 30 || days === 31) return 'Monthly'
  if (days === 90 || days === 91 || days === 92) return 'Quarterly'
  if (days === 182 || days === 183) return 'Every 6 months'
  if (days === 365 || days === 366) return 'Annually'
  return `Every ${days} days`
}

const NextOccurrenceBadge = ({ task, compact = false }) => {
  const obligation = task?.complianceObligation
  const next = obligation?.nextOccurrenceAt
  if (!next) return null

  const label = cadenceText(obligation.cadenceDays, obligation.cadenceWeekday)
  const nextText = moment(next).format('D MMM YYYY')

  return (
    <Badge title={`This is part of a recurring obligation (${label.toLowerCase()}). The next one is due ${nextText}.`}>
      <RepeatRoundedIcon style={{ fontSize: 13 }} />
      <span>{compact ? `Next ${moment(next).format('D MMM')}` : `${label} · next ${nextText}`}</span>
    </Badge>
  )
}

export default NextOccurrenceBadge

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e6f7f9;
  color: #0e7490;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
`
